import { Box, Stack, Typography } from "@mui/material";
import { colors } from "../constants/designTokens";

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <Stack
      direction={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "flex-start", lg: "center" }}
      spacing={1.5}
      sx={{ mb: 0.5 }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "baseline" },
          gap: { xs: 0.4, md: 1.2 },
          minWidth: 0,
          flexWrap: "wrap",
        }}
      >
        <Typography sx={{ color: colors.text, fontSize: { xs: 24, md: 27 }, fontWeight: 900, lineHeight: 1.1 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography sx={{ color: colors.muted, fontSize: 14, lineHeight: 1.35 }}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {actions && (
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
          {actions}
        </Stack>
      )}
    </Stack>
  );
}

